<template>
  <div class="sql-item">
    <div class="flex">
      <div class="sql-delete" v-if="type != 'run'">
        <a-icon type="delete" @click="deleteItem" />
      </div>
      <div class="sql-run" v-else-if="type == 'run'">
        <a-button icon="step-forward" size="large" @click="pageToEditor" />
        <span class="mgt-16">运行时间: {{ timestamp2Date(runTime) }}</span>
        <span class="mgt-4">结束时间: {{ timestamp2Date(finishTime) }}</span>
      </div>
      <div class="content" v-highlight>
          <code class="SQL">{{ code }}</code>
      </div>
    </div>
    <div class="result" v-if="type != 'script'">
      <span v-if="showMsg" v-bind:class="showError ? 'red' : ''" style="white-space: pre-wrap">{{ message }}</span>
      <result-table :columns="columns" :data-source="rows" :result="item" :showSQL="false" v-else></result-table>
    </div>
  </div>
</template>

<script>
import ResultTable from '@/components/Custom/ResultTable.vue'
import { timestamp2Date } from '@/utils/util'

export default {
  name: 'SqlItem',
  components: { ResultTable },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: 'run',
    },
  },
  data() {
    return {
      runTime: '',
      finishTime: '',
      showError: false,
      showMsg: true,
      message: '',
      columns: [],
      rows: [],
    }
  },
  computed: {
    code() {
      return this.item ? this.item.sql : ''
    },
  },
  mounted() {
    this.runTime = this.item.startTime
    this.finishTime = this.item.endTime
    if (this.item.type == 'error') {
      this.showError = true
      this.message = this.item.message
    } else {
      this.showError = false
      if (this.item?.columns?.length) {
        this.showMsg = false
        const tempColumns = []
        this.item.columns.forEach((column) => {
          const temp = {
            title: column.name,
            dataIndex: column.name,
            width: 160,
            ellipsis: true,
          }
          tempColumns.push(temp)
        })
        this.columns = tempColumns
        this.rows = this.item.rows
      } else {
        this.showMsg = true
        this.message = this.item.sqlType == 'PL/SQL' ? this.item.plsqlResult.trim() : 'Succeed.'
      }
    }
  },
  methods: {
    timestamp2Date,
    pageToEditor() {
      this.$router.push({ name: 'Console', params: { sql: this.code, runImmediate: true } })
    },
    deleteItem() {
      this.$emit('deletItem', this.item)
    },
  },
}
</script>

<style lang="less" scoped>
.sql-item {
  border: 1px solid #e8e8e8;
  background: #fff;
  width: 100%;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 1px 2px 3px #dcdcdc, 0 2px 3px #e8e8e8;
  }
}
.sql-delete {
  flex: 1;
  font-size: 24px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sql-run {
  flex: 2;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // border-right: 1px #dcdcdc solid;
}
.content {
  height: 150px;
  overflow-y: auto;
  flex: 8;
  border-left: 1px #dcdcdc solid;
  padding: 8px 12px;
}
.result {
  border-top: 1px solid #e8e8e8;
  background: #f7f7f7;
  min-height: 48px;
  padding: 12px 18px;
}
.red {
  color: #e42b1e;
}
</style>
